import { takeLatest, call, put, all, select, takeEvery } from 'redux-saga/effects';
import * as AppUIStateActionTypes from '../../constants/shared/appStatesConstants';

export function* appUIStatesWatcher() {
    yield takeLatest(AppUIStateActionTypes.GROUP_DETAIL_API_GET_CONTACTS_REQUEST, getGroupContactsSaga);
}

function* getGroupContactsSaga(action) {
    try {
        // FDS API getContactsInGroupAPI has been removed - personal vault functionality disabled
        yield put({
            type: AppUIStateActionTypes.GROUP_DETAIL_API_GET_CONTACTS_FAILURE,
            err: new Error('Personal vault functionality has been removed')
        })
    } catch(err) {
        yield put({
            type: AppUIStateActionTypes.GROUP_DETAIL_API_GET_CONTACTS_FAILURE,
            err
        })
    }
}

export default appUIStatesWatcher;
export { getGroupContactsSaga };